import React from 'react'
import { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { Height } from '@mui/icons-material'
import Videos from './Videos'

import { fetchFromAPI } from '../utils/fetchFromAPI'
import { useParams } from 'react-router-dom'
const SearchFeed = () => {
    const [Video, setVideo] = useState([])
    const {id} = useParams()
    useEffect(() => {
        fetchFromAPI(`search?part=snippet&q=${id}`).then((data) => { setVideo(data.items) })
    }, [id])
    return (
        <Box p={2} sx={{ overflowY: 'auto', height: '90vh' }}>
            <Typography variant='h4' fontWeight='bold' mb={2} sx={{ color: 'white' }}>

                Search Results For:  <span style={{ color: '#FC1503' }}>
                    Videos
                </span>
            </Typography>
            <Videos video={Video} />
        </Box>
    )
}

export default SearchFeed